export const COMPETITOR_DOMAIN_ERROR_KEYS = {
    duplicate: "llmTracker.campaignQuery.editBrand.error.duplicate",
    matchesTrackedDomain: "llm.setup.error.identical-domain-and-competitor",
} as const;

export type CompetitorDomainErrorKey = (typeof COMPETITOR_DOMAIN_ERROR_KEYS)[keyof typeof COMPETITOR_DOMAIN_ERROR_KEYS];

export const COMPETITOR_BRAND_ERROR_KEYS = {
    empty: "llm.setup.modal.competitor.brand.error.empty",
    duplicate: "llmTracker.campaignQuery.editBrand.error.duplicate",
    invalidCharacters: "llm.setup.modal.competitor.brand.error.invalid_characters",
    notComposed: "llm.setup.modal.competitor.brand.error.not_composed",
} as const;

export type CompetitorBrandErrorKey = (typeof COMPETITOR_BRAND_ERROR_KEYS)[keyof typeof COMPETITOR_BRAND_ERROR_KEYS];

export interface ICompetitorBrandError {
    key: CompetitorBrandErrorKey;
    params?: { suggestion: string };
}

export interface ICompetitorBrandValidation {
    trimmedBrand: string;
    brandValidationError: ICompetitorBrandError | null;
}
